import { render, staticRenderFns } from "./sigplani_resumo.col-val.vue?vue&type=template&id=99f0597e&"
import script from "./sigplani_resumo.col-val.vue?vue&type=script&lang=js&"
export * from "./sigplani_resumo.col-val.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VSheet})
